import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import { CreditsSection, YourCreditsList, CreditsHeading, CreditsDate, CreditsPrice, CreditsType, CreditsDescription } from './styles';

const CreditsList = ({ transactions }) => (
  <CreditsSection>
    <CreditsHeading>Your credits</CreditsHeading>
    <YourCreditsList>
      {transactions.map(transaction => {
        const { date, amount, type, description } = transaction;
        let finalAmount;

        if (type !== 'Charge') {
          finalAmount = `$${amount.toFixed(2)}`;
        } else {
          finalAmount = `-$${Number(amount).toFixed(2)}`
        }

        return (
          <li key={`date-${date}-amount-${amount}`}>
            <CreditsDate>{moment(date).format('MMM DD, YYYY')}</CreditsDate>
            <CreditsPrice priceColo={amount > 0 ? '#505050' : '#1ab6ff'}>{finalAmount}</CreditsPrice>
            <CreditsType>{type}</CreditsType>
            <CreditsDescription>{description}</CreditsDescription>
          </li>
        )
      })}
    </YourCreditsList>
  </CreditsSection>
);

CreditsList.propTypes = {
  transactions: PropTypes.instanceOf(Array),
};

export default CreditsList;
